import { render, staticRenderFns } from "./RoomCamStudy.vue?vue&type=template&id=578c6589&scoped=true&"
import script from "./RoomCamStudy.vue?vue&type=script&lang=js&"
export * from "./RoomCamStudy.vue?vue&type=script&lang=js&"
import style0 from "./RoomCamStudy.vue?vue&type=style&index=0&id=578c6589&lang=scss&"
import style1 from "./RoomCamStudy.vue?vue&type=style&index=1&id=578c6589&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578c6589",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('578c6589')) {
      api.createRecord('578c6589', component.options)
    } else {
      api.reload('578c6589', component.options)
    }
    module.hot.accept("./RoomCamStudy.vue?vue&type=template&id=578c6589&scoped=true&", function () {
      api.rerender('578c6589', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/RoomCamStudy.vue"
export default component.exports